/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

/**
 * Represents the type of Participant in a session.
 */ 
export enum ParticipantType {
    Instructor = 0,
    Learner = 1,
    StandardizedPatient = 2,
    Unknown = 3,
}
